module.exports = __webpack_public_path__ + "static/Hero-home.fc92b020.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Hero-home.jpg
// module id = 494
// module chunks = 213534597649335